import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { HttpService } from 'src/app/services/http.service';
import { Subject, Observable } from 'rxjs';
import { tap, catchError, shareReplay, map } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class BundlesService {
    private authData: any;
    private bundlesSubject = new Subject();

    bundles$: Observable<any> = this.bundlesSubject.asObservable();

    constructor(private auth: AuthService, private http: HttpService) {
        this.authData = this.auth.getAuthData();
    }

    getBundlesData(pageNo: any) {
        let url = `${environment.apiUrlDomain}/bundles`;
        const queryParams = [];
        if (pageNo) {
            queryParams.push(`pageNo=${pageNo}`);
        }
        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.bundlesSubject.next({
                            type: 'BUNDLES_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.bundlesSubject.next({
                        type: 'BUNDLES_GET_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }
    getBundlesDataBySearch(searchKey: string = '', pageNo: any) {
        let url = `${environment.apiUrlDomain}/bundles`;
        const queryParams = [];
        if (searchKey) {
            queryParams.push(`any=${searchKey}`);
        }
        if (pageNo) {
            queryParams.push(`pageNo=${pageNo}`);
        }
        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.bundlesSubject.next({
                            type: 'BUNDLES_SEARCH_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.bundlesSubject.next({
                        type: 'BUNDLES_SEARCH_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getBundlesDataById(id: any) {
        const url = `${environment.apiUrlDomain}/bundles/${id}`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.bundlesSubject.next({
                            type: 'BUNDLES_ID_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.bundlesSubject.next({
                        type: 'BUNDLES_ID_GET_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    deleteBundlesData(id: any) {
        const url = `${environment.apiUrlDomain}/bundles/${id}`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .deleteRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    console.log('delete bundles Data:', response);
                    this.bundlesSubject.next({
                        type: 'BUNDLES_DELETE_SUCCESSFUL',
                        data: response.body,
                    });
                }),
                catchError((error: any) => {
                    this.bundlesSubject.next({
                        type: 'BUNDLES_DELETE_FAILED',
                        data: error,
                    });
                    throw Error;
                })
            )
            .subscribe();
    }

    getTiersData() {
        const url = `${environment.apiUrlDomain}/price-tier?projection=id%20name&nonEmptyTiers=true&status=1&pageSize=100`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.bundlesSubject.next({
                            type: 'TIERS_DROPDOWN_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.bundlesSubject.next({
                        type: 'TIERS_DROPDOWN_GET_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }
    getTypeData() {
        const url = `${environment.apiUrlDomain}/bundles/dropdown/list?dropdown=type`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.bundlesSubject.next({
                            type: 'TYPE_DROPDOWN_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.bundlesSubject.next({
                        type: 'TYPE_DROPDOWN_GET_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }
    getSubTypeData() {
        const url = `${environment.apiUrlDomain}/bundles/dropdown/list?dropdown=subType`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.bundlesSubject.next({
                            type: 'SUBTYPE_DROPDOWN_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error: any) => {
                    this.bundlesSubject.next({
                        type: 'SUBTYPE_DROPDOWN_GET_SUCCESSFUL',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    createBundles(
        name: string,
        description: string,
        type: string,
        subType: string,
        bannerArt: any,
        albumArt: any,
        squareArt: any,
        tierId: string,
        status: number
    ) {
        const url = `${environment.apiUrlDomain}/bundles`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        const data: any = {
            ...(name && { name }),
            ...(description && { description }),
            ...(type && { type }),
            ...(subType && { subType }),
            ...(bannerArt && { bannerArt }),
            ...(albumArt && { albumArt }),
            ...(squareArt && { squareArt }),
            ...(tierId && { tierId }),
            status,
        };

        console.log('my data is here', data);

        this.http
            .postRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    if (response.status == 201) {
                        this.bundlesSubject.next({
                            type: 'BUNDLES_CREATE_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    // console.log(response);
                }),
                catchError((error: any) => {
                    this.bundlesSubject.next({
                        type: 'BUNDLES_CREATE_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    editBundles(
        id: string,
        name: string,
        description: string,
        type: string,
        subType: string,
        bannerArt: any,
        albumArt: any,
        squareArt: any,
        tierId: string,
        status: number
    ) {
        const url = `${environment.apiUrlDomain}/bundles/${id}`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        const data: any = {
            ...(name && { name }),
            ...(description && { description }),
            ...(type && { type }),
            ...(subType && { subType }),
            bannerArt,
            albumArt,
            squareArt,
            ...(tierId && { tierId }),
            status,
        };

        console.log('my data is here', data);

        this.http
            .putRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.bundlesSubject.next({
                            type: 'BUNDLES_UPDATE_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    // console.log(response);
                }),
                catchError((error: any) => {
                    this.bundlesSubject.next({
                        type: 'BUNDLES_UPDATE_FAILED',
                        data: error,
                    });
                    throw error;
                })
            )
            .subscribe();
    }

    getBundlesContentData(id: string, pageNo: any = '') {
        let url = `${environment.apiUrlDomain}/bundles/${id}/items`;

        const queryParams = [];

        if (pageNo) {
            queryParams.push(`pageNo=${pageNo}`);
        }

        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.bundlesSubject.next({
                            type: 'BUNDLES_CONTENT_DATA_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.bundlesSubject.next({
                        type: 'BUNDLES_CONTENT_DATA_GET_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getSearchedListdata(searchKey: any, pageNo: any) {
        console.log('searchkay:any', searchKey);

        let url = `${environment.apiUrlDomain}/channels`;
        const queryParams = [];
        queryParams.push(`status=1`);
        queryParams.push(`isBundle=true`);
        queryParams.push(`pageNo=${pageNo}`);
        queryParams.push(`projection=woiId%20id%20name%20image`);

        if (searchKey) {
            queryParams.push(`any=${searchKey}`);
        }

        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };
        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.bundlesSubject.next({
                            type: 'BUNDLES_LIST_SEARCH_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.bundlesSubject.next({
                        type: 'BUNDLES_LIST_SEARCH_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }
    updateBundlesListData(id: string, items: Array<string>) {
        console.log('id and items in updatecategorylist', id, items);

        const url = `${environment.apiUrlDomain}/bundles/${id}/items`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        const data = {
            items: items,
        };

        this.http
            .postRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    if (response.status == 201) {
                        this.bundlesSubject.next({
                            type: 'BUNDLES_LIST_UPDATE_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.bundlesSubject.next({
                        type: 'BUNDLES_LIST_UPDATE_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getBundlesPreviewData(id: any) {
        const url = `${environment.apiUrlDomain}/bundles/${id}/items`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.bundlesSubject.next({
                            type: 'BUNDLES_PREVIEW_ID_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                }),
                catchError((error) => {
                    this.bundlesSubject.next({
                        type: 'BUNDLES_PREVIEW_ID_GET_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }
}
